export default __webpack_public_path__ + "assets/d66ba50137e9b736923f431971c1f506.png";